import React from 'react';

import type { OrderDetailsFieldView } from '@src/features/orders/details/types';

import { OrderDetailsField } from './OrderDetailsField';
import { OrderDetailsColumnRoot } from './styles';

export type OrderDetailsColumnProps = {
  fields: OrderDetailsFieldView[];
};

export const OrderDetailsColumn = (props: OrderDetailsColumnProps) => {
  const { fields } = props;

  return (
    <OrderDetailsColumnRoot>
      {fields.map((field) => (
        <OrderDetailsField key={field.key} field={field} />
      ))}
    </OrderDetailsColumnRoot>
  );
};

export default OrderDetailsColumn;
